import type { ClausePosture } from "@/types/drafting";

const POSTURE_LABELS: Record<ClausePosture, string> = {
  "pro-company": "Pro-Company (Strict)",
  balanced: "Balanced",
  "pro-counterparty": "Pro-Executive (Lenient)",
  "market-standard": "Standard",
};

export function formatClauseCategoryLabel(category: string | null | undefined): string {
  if (!category) return "General";
  return category
    .split("-")
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}

export function formatClauseVariantLabel(
  posture: string | null | undefined,
  clauseCategory?: string | null
): string {
  if (posture && posture in POSTURE_LABELS) {
    return POSTURE_LABELS[posture as ClausePosture];
  }
  if (clauseCategory) {
    return clauseCategory
      .split("-")
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
      .join(" ");
  }
  return "Alternative";
}
